import React from 'react';
import { Link } from 'react-router-dom';
import { useGetBlogCategoriesQuery } from '../../../redux/slices/blogCategorySlice';
import BlogSearch from './BlogSearch';

import sidebarStyles from '../../../../stylesheets/public/layouts/SidebarLayout.module.postcss';
import styles from './BlogSidebar.module.postcss';

function BlogSidebar() {
  const { data = {} } = useGetBlogCategoriesQuery();
  const blogCategories = data.blog_categories || [];

  return (
    <div className={sidebarStyles.Sidebar}>

      <div>
        <BlogSearch />
      </div>

      <div className={sidebarStyles.Sidebar_item}>
        <div className={sidebarStyles.Sidebar_header}>
          <h3 className='u-phosphate u-mb0'>Categories</h3>
        </div>
        <div className={styles.BlogSidebar_List}>

          <div className={styles.BlogSidebar_ListItem}>
            <Link to='/blog'>All categories</Link>
          </div>

          { blogCategories.map((category) => {
            if (category.post_count === 0) return null;
            return (
              <div className={styles.BlogSidebar_ListItem} key={'blogSidebar-' + category.id}>
                <Link to={'/blog/category/' + category.id}>
                  {category.name}
                </Link>
              </div>
            );
          }) }

        </div>
      </div>

    </div>
  );
}

export default BlogSidebar;
